(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mas-announcement-bar"]) return;
  try {
    
class MasAnnouncementRotator extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-dot]'));
    this.interval = parseInt(this.dataset.interval, 10) || 6000;
    this.pauseOnHover = this.dataset.pauseOnHover === 'true';
    this.index = 0;
    this.timer = null;
    this.userPaused = false;

    if (this.slides.length < 2) return;

    this.onVisibility = () => (document.hidden ? this.stop() : this.start());
    this.onEnter = () => this.pause();
    this.onLeave = () => this.resume();

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.go(parseInt(dot.dataset.index, 10));
        this.restart();
      });
    });

    if (this.pauseOnHover) {
      this.addEventListener('mouseenter', this.onEnter);
      this.addEventListener('mouseleave', this.onLeave);
    }
    this.addEventListener('focusin', this.onEnter);
    this.addEventListener('focusout', this.onLeave);
    document.addEventListener('visibilitychange', this.onVisibility);

    // Theme Editor: jump to the block being edited and hold there.
    if (window.Shopify && window.Shopify.designMode) {
      this.onBlockSelect = (e) => {
        const slide = e.target.closest('[data-slide]');
        if (!slide || !this.contains(slide)) return;
        this.go(parseInt(slide.dataset.index, 10));
        this.userPaused = true;
        this.stop();
      };
      this.onBlockDeselect = () => { this.userPaused = false; this.start(); };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    this.setupTickers();
    this.onResize = () => {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => this.setupTickers(), 150);
    };
    window.addEventListener('resize', this.onResize);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => this.setupTickers());
    }

    this.start();
  }

  // Copy wider than its slot scrolls continuously instead of being cut off.
  setupTickers() {
    this.querySelectorAll('[data-ticker]').forEach((box) => {
      const run = box.querySelector('[data-ticker-run]');
      if (!run) return;
      box.querySelectorAll('[data-ticker-clone]').forEach((c) => c.remove());
      box.classList.remove('is-ticking');
      if (run.scrollWidth <= box.clientWidth + 1) return;
      const clone = run.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-ticker-clone', '');
      box.appendChild(clone);
      const pxPerSecond = 38;
      const distance = run.scrollWidth + 44;
      box.style.setProperty('--ticker-duration', `${Math.max(6, distance / pxPerSecond).toFixed(1)}s`);
      box.classList.add('is-ticking');
    });
  }

  disconnectedCallback() {
    this.stop();
    window.removeEventListener('resize', this.onResize);
    document.removeEventListener('visibilitychange', this.onVisibility);
    if (this.onBlockSelect) {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
    }
  }

  go(i) {
    const next = (i + this.slides.length) % this.slides.length;
    if (next === this.index && this.slides[next].classList.contains('is-active')) return;
    this.slides[this.index].classList.remove('is-active');
    this.slides[this.index].setAttribute('aria-hidden', 'true');
    this.index = next;
    const slide = this.slides[this.index];
    slide.classList.add('is-active');
    slide.removeAttribute('aria-hidden');
    this.style.setProperty('--ann-bg-1', getComputedStyle(slide).getPropertyValue('--slide-bg-1'));
    this.style.setProperty('--ann-bg-2', getComputedStyle(slide).getPropertyValue('--slide-bg-2'));
    this.dots.forEach((dot, d) => {
      const active = d === this.index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
      if (active) {
        // restart the progress fill animation
        const fill = dot.firstElementChild;
        fill.style.animation = 'none';
        void fill.offsetWidth;
        fill.style.animation = '';
      }
    });
  }

  next() { this.go(this.index + 1); }

  start() {
    if (this.userPaused || document.hidden) return;
    this.stop();
    this.timer = setInterval(() => this.next(), this.interval);
    this.classList.remove('is-paused');
  }

  stop() {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  }

  pause() { this.stop(); this.classList.add('is-paused'); }
  resume() { this.start(); }
  restart() { this.stop(); this.start(); }
}

if (!customElements.get('mas-announcement-rotator')) {
  customElements.define('mas-announcement-rotator', MasAnnouncementRotator);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["memorial-day-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.mas-md-bar').forEach(function (bar) {
    var endIso = bar.getAttribute('data-end');
    if (!endIso) return;
    var endMs = Date.parse(endIso);
    if (isNaN(endMs)) return;

    var allowDismiss = bar.getAttribute('data-allow-dismiss') === 'true';
    var showCountdown = bar.getAttribute('data-show-countdown') === 'true';
    var storageKey = 'mas-md-bar-dismissed:' + bar.id;

    // Hide if dismissed this browser session
    if (allowDismiss) {
      try {
        if (sessionStorage.getItem(storageKey) === '1') {
          bar.setAttribute('hidden', '');
          return;
        }
      } catch (e) { /* sessionStorage blocked — fall through */ }
    }

    // Hide if past end date
    if (Date.now() > endMs) {
      bar.setAttribute('hidden', '');
      return;
    }

    // Dismiss handler
    var dismissBtn = bar.querySelector('[data-dismiss]');
    if (dismissBtn) {
      dismissBtn.addEventListener('click', function () {
        bar.setAttribute('hidden', '');
        try { sessionStorage.setItem(storageKey, '1'); } catch (e) { /* ignore */ }
      });
    }

    // Live countdown
    if (showCountdown) {
      var daysEl = bar.querySelector('[data-days]');
      var hoursEl = bar.querySelector('[data-hours]');
      var minsEl = bar.querySelector('[data-mins]');

      function pad(n) { return n < 10 ? '0' + n : String(n); }

      function tick() {
        var diff = endMs - Date.now();
        if (diff <= 0) {
          bar.setAttribute('hidden', '');
          clearInterval(timer);
          return;
        }
        var totalSec = Math.floor(diff / 1000);
        var days = Math.floor(totalSec / 86400);
        var hours = Math.floor((totalSec % 86400) / 3600);
        var mins = Math.floor((totalSec % 3600) / 60);
        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minsEl) minsEl.textContent = pad(mins);
      }
      tick();
      var timer = setInterval(tick, 30000); // minute-granularity, low CPU
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
